import line from "../../../assets/images/section2_line.svg";
import Container from "../../../components/container";
export default function Section8() {
   return (<section className="section5 mt-[76px]">
      <Container className="!px-[30px] lg:px-[40px] 2xl:!px-0">
         <div className="flex flex-col">
            <div className="flex items-center">
               <h3 className="text-[#EB4A00] font-bold text-[24px] leading-[30px] md:text-[32px] md:leading-[40px] lg:text-[40px] pr-[10px]">Let’s build something great!</h3>
               <div className="h-[1px]">
                  <img src={line} alt="line" style={{ objectFit: 'contain' }} />
               </div>
            </div>
            <p className="text-[20px] leading-[30px] text-[#000000] pt-[16px] font-normal leading-[30px]">Have a game to ship, an app to scale, or a concept to validate? Tell us what you need and we’ll propose a clear plan, timeline, and budget.</p>
         </div>
      </Container>
   </section>);
}